import styled from 'styled-components';

export interface IBackgroundProps {
  children?: React.ReactNode;
  withImage?: string;
  unloaded?: boolean;
  overlay?: boolean;
}

export const StyledBackground = styled.div<{ $backgroundImage?: string, $unloaded?: boolean, $overlay?: boolean }>`
  position: relative;
  overflow: hidden;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  transition: opacity 500ms 400ms;
  ${props => props.$unloaded && `
    opacity: 0; 
    pointer-events: none;`
  }
  > * {  
    transition: opacity 500ms;
    ${props => props.$unloaded && `
      opacity: 0; 
      pointer-events: none;`
    }
  }
  ${props => props.$overlay && `
    position: absolute;
    pointer-events: none;
    top: 0px;
    left: 0px;
    width: 100%;
    z-index: 99;
    background: black;
    `
  }

  ${({ $backgroundImage }) => $backgroundImage && `
    background-image: url(${$backgroundImage});
    background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat;
  `}
`

export const StyledEllipse = styled.div`
  position: absolute;
  width: 688px;
  height: 688px;
  top: -260px;
  left: 30px;
  background: radial-gradient(circle, rgb(106, 104, 104, 0.6) 0%, rgba(0, 0, 0, 0) 50%);
  opacity: 0.8;
  z-index: 1;
`

export const StyledContent = styled.div`
  z-index: 2;
`